import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d204fc3")

_pushScopeId("data-v-6d204fc3")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h2", null, "患者登録")
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("登録確認")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("以下の内容で登録します。")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("登録完了")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("登録完了しました。")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("戻る ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("次へ ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("登録 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("完了 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("登録してもいいですか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_patient_page = _resolveComponent("patient-page")
  const _component_confirm_page = _resolveComponent("confirm-page")
  const _component_complete_page = _resolveComponent("complete-page")
  const _component_vue_content = _resolveComponent("vue-content")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_button_frame = _resolveComponent("vue-button-frame")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _hoisted_1,
          _createVNode("div", null, _toDisplayString(_ctx.today), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content, null, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.inquiryPages, (_, i) => {
            return (_openBlock(), _createBlock(_component_patient_page, {
              key: `inquiryPage-${i}`,
              page: i,
              next: _ctx.onNext,
              show: _ctx.page===i,
              ref: _ctx.setPageRef
            }, null, 8, ["page", "next", "show"]))
          }), 128)),
          _withDirectives(_createVNode(_component_confirm_page, { items: _ctx.confirmItems }, {
            title: _withId(() => [
              _hoisted_2
            ]),
            message: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["items"]), [
            [_vShow, _ctx.page === _ctx.maxPage]
          ]),
          _withDirectives(_createVNode(_component_complete_page, { items: _ctx.confirmItems }, {
            title: _withId(() => [
              _hoisted_4
            ]),
            message: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["items"]), [
            [_vShow, _ctx.page === _ctx.maxPage + 1]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_vue_button_frame, null, {
        left: _withId(() => [
          (_ctx.page<=_ctx.maxPage)
            ? (_openBlock(), _createBlock(_component_normal_button, {
                key: 0,
                class: "vue-button-frame-button",
                state: "normal",
                onClick: _ctx.onPrev
              }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        right: _withId(() => [
          (_ctx.page<_ctx.maxPage)
            ? (_openBlock(), _createBlock(_component_normal_button, {
                key: 0,
                class: "vue-button-frame-button",
                state: "normal",
                onClick: _ctx.onNext
              }, {
                default: _withId(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.page===_ctx.maxPage)
            ? (_openBlock(), _createBlock(_component_normal_button, {
                key: 1,
                class: "vue-button-frame-button",
                state: "warning",
                onClick: _ctx.onSubmit
              }, {
                default: _withId(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.page===_ctx.maxPage + 1)
            ? (_openBlock(), _createBlock(_component_normal_button, {
                key: 2,
                class: "vue-button-frame-button",
                state: "normal",
                onClick: _ctx.complete
              }, {
                default: _withId(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "confirmRef",
        onYes: _ctx.yes
      }, {
        default: _withId(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})